const locale = {
  placeholder: 'à¹à¸¥à¸·à¸­à¸à¹à¸§à¸¥à¸²',
};

export default locale;
